import styles from './FileItem.module.css'

interface FileItemProps {
  name: string
  type: string
  size: string
  uploadedAt: string
  source: 'whatsapp' | 'upload'
}

export default function FileItem({ name, type, size, uploadedAt, source }: FileItemProps) {
  const getFileIcon = (type: string) => {
    if (type.startsWith('image/')) return '🖼️'
    if (type.includes('pdf')) return '📄'
    if (type.includes('word') || type.includes('doc')) return '📝'
    if (type.includes('excel') || type.includes('sheet')) return '📊'
    if (type.includes('powerpoint') || type.includes('presentation')) return '📈'
    if (type.includes('video/')) return '🎥'
    if (type.includes('audio/')) return '🎵'
    return '📁'
  }

  const getFileColor = (type: string) => {
    if (type.startsWith('image/')) return '#10b981'
    if (type.includes('pdf')) return '#ef4444'
    if (type.includes('word') || type.includes('doc')) return '#3b82f6'
    if (type.includes('excel') || type.includes('sheet')) return '#059669'
    if (type.includes('powerpoint') || type.includes('presentation')) return '#f59e0b'
    if (type.includes('video/')) return '#8b5cf6'
    if (type.includes('audio/')) return '#f97316'
    return '#6b7280'
  }

  return (
    <div className={styles.fileItem}>
      <div 
        className={styles.fileIcon} 
        style={{ background: `linear-gradient(135deg, ${getFileColor(type)}, ${getFileColor(type)}dd)` }}
      >
        {getFileIcon(type)}
      </div>
      <div className={styles.fileInfo}>
        <div className={styles.fileName}>{name}</div>
        <div className={styles.fileMeta}>
          {uploadedAt} • via {source === 'whatsapp' ? 'WhatsApp' : 'Upload'}
        </div>
      </div>
      <div className={styles.fileSize}>{size}</div>
    </div>
  )
}